import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import styles from './Contact.module.css';

const Contact = () => {
     const form = useRef();

     const handleSubmit = (e) => {
          e.preventDefault();
          const serviceID = 'default_service';
          const templateID = 'template_jdt6lvo';
          const publicKey = 'l9B5S3CTeTfZgBMMc';

          emailjs.sendForm(serviceID, templateID, form.current, publicKey).then(
               (result) => {
                    console.log(result.text);
               },
               (error) => {
                    console.log(error.text);
               }
          );

          e.target.reset();
     };

     return (
          <div className={styles.container}>
               <div className={styles.border_top}></div>
               <div id="contact" className={styles.title_container}>
                    <p
                         // data-aos="fade-right"
                         className={styles.title}
                    >
                         CONTACT
                    </p>
                    <div
                         // data-aos="fade-right" data-aos-delay="50"
                         className={styles.line}
                    ></div>
                    <p
                         // data-aos="fade-left"
                         className={styles.subtitle}
                    >
                         Have a question or want to work together?
                    </p>
               </div>
               <form ref={form} className={styles.form_container} onSubmit={handleSubmit}>
                    <input
                         name="name"
                         placeholder="Name"
                         type="text"
                         className={styles.input}
                         required="on"
                         autoComplete="off"
                    />
                    <input
                         name="email"
                         placeholder="Email"
                         type="email"
                         className={styles.input}
                         required="on"
                         autoComplete="off"
                    />
                    <textarea
                         name="message"
                         type="text"
                         rows="5"
                         placeholder="Your Message"
                         className={styles.input}
                         required="on"
                         autoComplete="off"
                    />
                    <button id="button" type="submit" className={styles.button}>
                         SUBMIT
                         <span></span>
                    </button>
               </form>
          </div>
     );
};

export default Contact;
